import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-search\"><path d=\"m23.721 22.375-5.4-5.4a10.372 10.372 0 1 0-1.346 1.346l5.4 5.4a.952.952 0 0 0 1.346-1.346M1.9 10.358a8.454 8.454 0 1 1 8.454 8.454A8.464 8.464 0 0 1 1.9 10.358\" data-name=\"Path 45\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol